import { useContent } from "@/context/ContentContext";

export const CONTACT = {
  phoneDisplay: "+973 1330 3332",
  phoneLink: "tel:+97313303332",
  whatsapp: "https://wa.me/97313303332",
  instagram: "https://www.instagram.com/travelers_bh/",
  mapsUrl:
    "https://www.google.com/maps/place/%D8%AF%D9%84%D9%8A%D9%84+%D8%A7%D9%84%D9%85%D8%B3%D8%A7%D9%81%D8%B1+%D9%84%D9%84%D8%AD%D8%AC%D9%88%D8%B2%D8%A7%D8%AA/@26.2353968,50.5353126,17z/data=!3m1!4b1!4m6!3m5!1s0x3e49adc4003d9a55:0x40fa25a79cd23864!8m2!3d26.235392!4d50.5378875!16s%2Fg%2F11hzctw112?entry=ttu",
  directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=26.235392,50.5378875",
  mapEmbed: "https://maps.google.com/maps?q=26.235392,50.5378875&hl=ar&z=16&output=embed",
  addressAr: "مكتب 606، مبنى 2358، طريق 2830، مجمع 428، منطقة السيف، مملكة البحرين",
  addressEn: "Office 606, Building 2358, Road 2830, Block 428, Seef District, Bahrain",
  plusCode: "6GPQ+55 Seef",
};

// Central company contact: admin-edited settings (loaded via /api/content) override the defaults above.
export const useContact = () => {
  const { content } = useContent();
  const c = content?.contact || {};
  const digits = String(c.phone || "97313303332").replace(/[\s+\-()]/g, "");
  return {
    ...CONTACT,
    phoneDisplay: c.phoneDisplay || CONTACT.phoneDisplay,
    phoneLink: `tel:+${digits.replace(/^\+/, "")}`,
    whatsapp: c.whatsapp || CONTACT.whatsapp,
    instagram: c.instagram || CONTACT.instagram,
    addressAr: c.address || CONTACT.addressAr,
    addressEn: c.addressEn || CONTACT.addressEn,
    plusCode: c.plusCode || CONTACT.plusCode,
    mapsUrl: c.mapsUrl || CONTACT.mapsUrl,
    directionsUrl: c.directionsUrl || CONTACT.directionsUrl,
    mapEmbed: c.mapEmbed || CONTACT.mapEmbed,
    instagramHandle: c.instagram ? `@${String(c.instagram).replace(/\/$/, "").split("/").pop()}` : "@travelers_bh",
    workingHours: content?.workingHours || "",
    email: content?.email || "",
  };
};
